import * as favoriteAPI from '@adobe/edex/frontend/api/favorite';

const favorite = {
  namespaced: true,
  state: {
    favorite: [],
  },
  mutations: {
    setList(state, favorite) {
      state.favorite = favorite;
    },
  },
  actions: {
    create({ commit, state }, { entityID, entityType }) {
      return favoriteAPI.create(entityID, entityType);
    },
    remove({ commit, state }, { entityID, entityType }) {
      return favoriteAPI.remove(entityID, entityType);
    },
    async list({ commit }) {
      const { status, data } = await favoriteAPI.paginate();
      if (status === 200) {
        commit('setList', data);
      }
    },
  },
};

export default favorite;
